import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

export const commissionSerializeMap: SerializeMap<Commission> = {
  commissionType: "commission_type",
  commissionValue: "commission_value",
};

export const serializeCommission = buildSerializer<Commission>(
  commissionSerializeMap,
  "commission",
);

export const deserializeCommission = buildDeserializer<Commission>(
  commissionSerializeMap,
  "commission",
);
